import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { FeatureFlagsService } from '../services';

@Injectable()
export class DynamicRatingFeatureGuard implements CanActivate {
  constructor(
    private router: Router,
    private featureFlagsSvc: FeatureFlagsService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    // Check if dynamic rating feature flag is enabled
    const dynamicRatingEnabled = await firstValueFrom(this.featureFlagsSvc.isEnabled('DYNAMIC_RATING'));

    if (!dynamicRatingEnabled) {
      // Redirect to policy details if feature is not enabled
      const policyId = this.findPolicyId(route);
      return this.router.createUrlTree(['/policies', policyId]);
    }

    return true;
  }

  private findPolicyId(route: ActivatedRouteSnapshot): string {
    return route.params['policyId'] || (route.parent ? this.findPolicyId(route.parent) : '');
  }
}
